// @flow

import * as React from 'react';

import { Button, ButtonIcon, Footer } from '@sonyged/ext-proc';

import type { NewRound } from './domain/Round';
import { PizzaStaff } from './PizzaStaff';
import { StoreTalkBubble, StoreTalkBubbleArrow } from './StoreTalkBubble';
import AutoScaleContainer from './AutoScaleContainer';
import PizzaCustomer from './PizzaCustomer';
import PizzaStore from './PizzaStore';
import PizzaTable from './PizzaTable';

type Props = {
  round: NewRound,
  onNext: NewRound => void,
  onBack?: () => void,
};

type State = {
  talkingCustomer: number | null,
  staffLine: ?string,
  scale: number,
};

class PizzaOrderView extends React.Component<Props, State> {
  state = {
    talkingCustomer: null,
    staffLine: 'いらっしゃいませ。',
    scale: 1,
  };

  constructor(props: Props) {
    super(props);

    (this: any).handleClickNext = this.handleClickNext.bind(this);
    (this: any).handleScaleChange = this.handleScaleChange.bind(this);
  }

  handleClickNext() {
    if (this.state.talkingCustomer === null) {
      this.setState({ talkingCustomer: 0, staffLine: null });
      return;
    }

    if (this.state.talkingCustomer < this.props.round.customers.length - 1) {
      this.setState({ talkingCustomer: this.state.talkingCustomer + 1 });
      return;
    }

    if (!this.state.staffLine) {
      this.setState({ staffLine: 'かしこまりました。' });
      return;
    }

    this.props.onNext(this.props.round);
  }

  handleScaleChange(scale: number) {
    this.setState({ scale });
  }

  render() {
    const {
      round: { customers },
    } = this.props;
    const { talkingCustomer } = this.state;
    return (
      <div className="pizza-inner-view pizza-order-view">
        <div className={'proc-contents padding relative'}>
          <AutoScaleContainer
            className="tertiary100-bg-color"
            preferedWidth={864}
            preferedHeight={474}
            preferedMinHeight={474}
            preferedMinWidth={360}
            onScaleChange={this.handleScaleChange}
          >
            <PizzaStore>
              {talkingCustomer !== null && <StoreTalkBubble>{customers[talkingCustomer].talk()}</StoreTalkBubble>}
              {this.props.round.customers[0] && (
                <PizzaCustomer
                  talking={talkingCustomer === 0}
                  customer={this.props.round.customers[0]}
                  position={customers.length === 3 ? 'left' : 'center'}
                >
                  <StoreTalkBubbleArrow />
                </PizzaCustomer>
              )}
              {this.props.round.customers[1] && (
                <PizzaCustomer
                  talking={talkingCustomer === 1}
                  customer={this.props.round.customers[1]}
                  position={customers.length === 3 ? 'center' : 'right'}
                >
                  <StoreTalkBubbleArrow />
                </PizzaCustomer>
              )}
              {this.props.round.customers[2] && (
                <PizzaCustomer
                  talking={talkingCustomer === 2}
                  customer={this.props.round.customers[2]}
                  position="right"
                >
                  <StoreTalkBubbleArrow />
                </PizzaCustomer>
              )}
              <PizzaTable />
            </PizzaStore>
          </AutoScaleContainer>
          <PizzaStaff scale={this.state.scale} message={this.state.staffLine} />
        </div>
        <Footer.nav
          navItem={
            this.props.onBack ? (
              <Button.normal onClick={this.props.onBack}>
                <ButtonIcon.back />
              </Button.normal>
            ) : null
          }
        >
          <Button.attention onClick={this.handleClickNext}>つぎへ</Button.attention>
        </Footer.nav>
      </div>
    );
  }
}

export default PizzaOrderView;
